module.exports = __webpack_public_path__ + "img/one.66836286.jpg";